import React from 'react';

import { LazyThemesPage } from '@confluence/site-settings/entry-points/ThemesPage.ts';
import { ADMIN_THEMES_ANALYTICS_SOURCE } from '@confluence/site-settings/entry-points/themesConstants.ts';
import { ADMIN_HOME_ID } from '@confluence/app-navigation/entry-points/navigationIDs.ts';

export const AdminThemesRoute = () => <LazyThemesPage />;

AdminThemesRoute.NAVIGATION_PARAMS = () => ({
	Screen: {
		screenEvent: { name: ADMIN_THEMES_ANALYTICS_SOURCE },
	},
	MainLayout: {
		navView: ADMIN_HOME_ID,
	},
});
